import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canAccessAdminWeb, useSession } from '../auth/session';

const CHANGE_PASSWORD_PATH = '/doi-mat-khau';

/**
 * Chốt chặn đăng nhập cho toàn bộ khu vực admin.
 *
 * Guard phía client CHỈ để điều hướng cho đỡ khó chịu — quyền thật do server quyết
 * theo BR-801, và endpoint nào cũng tự kiểm lại.
 *
 * Khôi phục phiên do `RootLayout` lo, tới đây `isRestoring` đã xong.
 */
export function RequireAuth() {
  const session = useSession((state) => state.session);
  const location = useLocation();

  if (!session) {
    // Nhớ trang đang muốn vào để đăng nhập xong quay lại đúng chỗ.
    // Không nhớ /doi-mat-khau: đó là màn buộc đổi MK, lưu làm `from` sẽ tạo vòng
    // lặp (đổi xong → login → lại bị đẩy về đổi MK dù cờ đã tắt).
    const from =
      location.pathname === CHANGE_PASSWORD_PATH ? undefined : location.pathname;
    return (
      <Navigate
        to="/login"
        replace
        state={from ? { from } : undefined}
      />
    );
  }

  if (!canAccessAdminWeb(session)) {
    return <Navigate to="/khong-du-quyen" replace />;
  }

  // Server trả 403 cho mọi endpoint khác khi tài khoản còn nợ đổi mật khẩu. Không
  // chặn ở đây thì người dùng vào được trang nhưng mọi bảng đều báo lỗi khó hiểu.
  if (session.mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return <Outlet />;
}
